module.exports = __webpack_public_path__ + "static/media/photo1.6ea84c8e.png";